import { createMemo } from "solid-js";
import { useAuth } from "../context/auth";

export default function usePermissions() {
  const [auth] = useAuth();

  return createMemo(() => {
    if (!auth.user) return new Set<string>(); // kosong kalau logout

    const perms: string[] = auth.user.is_custom
      ? auth.user.permissions || []
      : auth.user.roles?.find((r: any) => r?.appCode === "sso")?.permissions ||
        [];

    return new Set(perms); // otomatis remove duplicate + O(1) lookup
  });
}
